// import React, { useState, useEffect } from "react";
// import {
//   InputLabel,
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   Typography,
// } from "@mui/material";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { MdEmail } from "react-icons/md";
// import { Link } from "react-router-dom";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import LocalIP from "../../api/LocalIP";
// import BaseURL from "../../api/baseURL"
// import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import { FaLock } from "react-icons/fa";

// const Signup_URL = "/user/signup";

// const Signup = () => {
//   const navigate = useNavigate();
//   const [values, setValues] = useState({
//     fullName: "",
//     email: "",
//     password: "",
//     confirmPassword: "",
//     type: 1,
//     companyName: "",
//   });

//   const [isEmailSuccessfullySent, setIsEmailSuccessfullySent] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [passwordError, setPasswordError] = useState(false);
//   const [confirmPasswordError, setConfirmPasswordError] = useState(false);

//   const [formErrors, setFormErrors] = useState({
//     fullNameError: false,
//     companyNameError: false,
//     emailError: false,
//     passwordError: false,
//     confirmPasswordError: false,
//     typeError: false,
//   });

//   useEffect(() => {
//     const isPasswordValid =
//       values.password.length >= 8 &&
//       /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(values.password);
//     setPasswordError(!isPasswordValid);
//     setConfirmPasswordError(values.confirmPassword !== values.password);
//   }, [values.password, values.confirmPassword]);

//   const handleChange = (name) => (e) => {
//     const value = e.target.value;
//     setValues({ ...values, [name]: value });
//   };

//   const isFormValid = () => {
//     return (
//       values.fullName &&
//       values.email &&
//       values.companyName &&
//       values.password &&
//       values.confirmPassword &&
//       !passwordError &&
//       !confirmPasswordError
//     );
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
  
//     if (passwordError || confirmPasswordError) {
//       toast.error("Please fix password errors before continuing.");
//       return;
//     }
//     if (!isFormValid()) {
//       toast.error("Please fill the form correctly before continuing.");
//       return;
//     }
  
//     try {
//       const { data } = await BaseURL.post(Signup_URL, {
//         ...values,
//         type: parseInt(values.type),
//       });
  
//       if (data.statusCode === 200) {
//         setValues({
//           fullName: "",
//           companyName: "",
//           email: "",
//           type: 1,
//           password: "",
//           confirmPassword: "",
//         });
//         toast.success("Sign up successful, please login!");
//         setIsEmailSuccessfullySent(true);
//       }
//     } catch (err) {
//       if (err.response && err.response.data && err.response.data.message) {
//         const errorMessage = err.response.data.message;
//         switch (errorMessage) {
//           case "Invalid e-mail address":
//           case "E-mail address already exists":
//             toast.error(errorMessage);
//             break;
//           default:
//             toast.error(errorMessage);
//             break;
//         }
//       } else {
//         toast.error(err);
//       }
//     }
//   };
  
//   const handleTogglePasswordVisibility = () => {
//     setShowPassword((prevShowPassword) => !prevShowPassword);
//   };

//   const handleToggleConfirmPasswordVisibility = () => {
//     setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
//   };

//   const handleOpenEmailApp = () => {
//     window.open("https://mail.google.com", "_blank");
//   };

//   return (
//     <div>
//       {!isEmailSuccessfullySent ? (
//         <div
//           className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative"
//           style={{
//             background:
//               "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
//             backgroundColor: "rgb(23,39,92)",
//           }}
//         >
//           <div className="sm:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2 "></div>
//           <div
//             className="sm:col-span-4 flex justify-center items-center text-3xl  p-2 border-l-2"
//             style={{ borderColor: "#214471" }}
//           >
//             <div className="w-fit flex justify-center">
//               <form
//                 className="flex flex-col w-full items-center"
//                 onSubmit={handleSubmit}
//               >
//                 <h1 className="text-white font-semibold text-3xl mb-10 text-center">
//                   Sign Up
//                 </h1>
//                 <div className="flex flex-col mb-4 w-96 text-white">
//                   <InputLabel
//                     className="text-white mb-1 text-base"
//                     style={{ color: "white" }}
//                   >
//                     Full Name
//                   </InputLabel>
//                   <TextField
//                     type="text"
//                     variant="outlined"
//                     size="small"
//                     placeholder="Full Name"
//                     name="fullName"
//                     value={values.fullName}
//                     onChange={handleChange("fullName")}
//                     required
//                     error={formErrors.fullNameError}
//                     InputProps={{
//                       style: {
//                         background: "white",
//                         boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
//                         borderColor: formErrors.fullNameError
//                           ? "red"
//                           : "initial",
//                       },
//                     }}
//                   />
//                   {formErrors.fullNameError && (
//                     <p className="text-red-500 text-sm">
//                       Please enter your full name
//                     </p>
//                   )}
//                 </div>
//                 {values.type === 1 && (
//                   <div className="flex flex-col mb-4 w-96 text-white">
//                     <InputLabel
//                       className="text-white mb-1 text-base"
//                       style={{ color: "white" }}
//                     >
//                       Company Name
//                     </InputLabel>
//                     <TextField
//                       type="text"
//                       variant="outlined"
//                       size="small"
//                       placeholder="Company Name"
//                       name="companyName"
//                       value={values.companyName}
//                       onChange={handleChange("companyName")}
//                       required
//                       error={formErrors.companyNameError}
//                       InputProps={{
//                         style: {
//                           background: "white",
//                           boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
//                           borderColor: formErrors.companyNameError
//                             ? "red"
//                             : "initial",
//                         },
//                       }}
//                     />
//                     {formErrors.companyNameError && (
//                       <p className="text-red-500 text-sm">
//                         Please enter the company name
//                       </p>
//                     )}
//                   </div>
//                 )}

//                 <div className="flex flex-col mb-4 w-96">
//                   <InputLabel
//                     className="text-white mb-1 text-base"
//                     style={{ color: "white" }}
//                   >
//                     Email
//                   </InputLabel>
//                   <TextField
//                     type="email"
//                     variant="outlined"
//                     size="small"
//                     placeholder="email"
//                     name="email"
//                     value={values.email}
//                     onChange={handleChange("email")}
//                     required
//                     error={formErrors.emailError}
//                     InputProps={{
//                       style: {
//                         background: "white",
//                         boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
//                         borderColor: formErrors.emailError ? "red" : "initial",
//                       },
//                     }}
//                   />
//                   {formErrors.emailError && (
//                     <p className="text-red-500 text-sm">
//                       Invalid e-mail address, please try again.
//                     </p>
//                   )}
//                 </div>
//                 <div className="flex flex-col mb-4 w-96">
//                   <InputLabel
//                     className="text-white mb-1 text-base"
//                     style={{ color: "white" }}
//                   >
//                     User Role
//                   </InputLabel>
//                   <TextField
//                     type="text"
//                     variant="outlined"
//                     size="small"
//                     name="type"
//                     value={values.type === 1 ? "Admin" : ""}
//                     onChange={handleChange("type")}
//                     required
//                     disabled
//                     error={formErrors.typeError}
//                     InputProps={{
//                       style: {
//                         background: "white",
//                         boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
//                         borderColor: formErrors.typeError ? "red" : "initial",
//                         color: "black",
//                       },
//                       endAdornment: (
//                         <div style={{ position: "relative" }}>
//                           <FaLock
//                             style={{
//                               position: "absolute",
//                               right: "8px",
//                               top: "50%",
//                               transform: "translateY(-50%)",
//                               color: "#ccc",
//                             }}
//                           />
//                         </div>
//                       ),
//                     }}
//                   />
//                 </div>
//                 <div className="flex flex-col mb-4 w-96">
//                 <InputLabel
//                     className="text-white mb-1 text-base"
//                     style={{ color: "white" }}
//                   >
//                     Password
//                   </InputLabel>
//                   <TextField
//                     type={showPassword ? "text" : "password"}
//                     variant="outlined"
//                     size="small"
//                     placeholder="Password"
//                     name="password"
//                     value={values.password}
//                     onChange={handleChange("password")}
//                     required
//                     error={passwordError}
//                     InputProps={{
//                       style: {
//                         background: "white",
//                         borderColor: formErrors.passwordError
//                           ? "red"
//                           : "initial",
//                         boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
//                       },
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton onClick={handleTogglePasswordVisibility}>
//                             {showPassword ? <VisibilityOff /> : <Visibility />}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                     onCopy={(e) => e.preventDefault()}
//                     onCut={(e) => e.preventDefault()}
//                     onPaste={(e) => e.preventDefault()}
//                   />
//                   {passwordError && (
//                     <p className="text-red-500 text-sm">Password must meet all validation criteria.</p>
//                   )}
//                 </div>
//                 <div className="flex flex-col mb-4 w-96">
//                 <InputLabel
//                     className="text-white mb-1 text-base"
//                     style={{ color: "white" }}
//                   >
//                     Confirm Password
//                   </InputLabel>
//                   <TextField
//                     type={showConfirmPassword ? "text" : "password"}
//                     variant="outlined"
//                     size="small"
//                     placeholder="Confirm Password"
//                     name="confirmPassword"
//                     value={values.confirmPassword}
//                     onChange={handleChange("confirmPassword")}
//                     required
//                     error={confirmPasswordError}
//                     InputProps={{
//                       style: {
//                         background: "white",
//                         boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
//                         borderColor: formErrors.confirmPasswordError
//                           ? "red"
//                           : "initial",
//                       },
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             onClick={handleToggleConfirmPasswordVisibility}
//                           >
//                             {showConfirmPassword ? (
//                               <VisibilityOff />
//                             ) : (
//                               <Visibility />
//                             )}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                     onCopy={(e) => e.preventDefault()}
//                     onCut={(e) => e.preventDefault()}
//                     onPaste={(e) => e.preventDefault()}
//                   />
//                   {confirmPasswordError && (
//                     <p className="text-red-500 text-sm">
//                       Passwords do not match.
//                     </p>
//                   )}
//                 </div>
//                 <Button
//                   type="submit"
//                   variant="contained"
//                   color="primary"
//                   sx={{ textTransform: "none" }}
//                   className="w-30 h-8 rounded-md mb-4 font-bold text-lg text-sm"
//                   disabled={!isFormValid()}
//                   style={{
//                     boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
//                     color: !isFormValid() ? "" : "#081A51",
//                     backgroundColor: !isFormValid() ? "" : "white",
//                     fontWeight: !isFormValid() ? "" : "bold",
//                   }}
//                 >
//                   Continue
//                 </Button>
//                 <p className="text-white text-base mt-5">
//                   Have an account?{" "}
//                   <Link to="/" className="text-white border-b-2 text-base ml-1">
//                     Login
//                   </Link>
//                 </p>
//               </form>
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div
//           className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative"
//           style={{
//             background:
//               "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
//             backgroundColor: "rgb(23,39,92)",
//           }}
//         >
//           <div className="sm:col-span-12 md:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2"></div>

//           <div
//             className="sm:col-span-6 flex justify-center items-center text-3xl p-2 border-l-2 relative"
//             style={{ borderColor: "#214471" }}
//           >
//             <div className="w-full flex justify-center items-center">
//               <div className="absolute inset-y-1/2 transform -translate-y-1/2 right-15 sm:right-25 w-2/3 bg-white rounded-lg h-2/3 flex flex-col justify-center items-center">
//                 <div className="flex justify-center items-center w-1/3 h-1/3 bg-blue-950 rounded-full">
//                   <MdEmail style={{ color: "white", fontSize: "4em" }} />
//                 </div>
//                 <div className="text-center mt-8">
//                   <p className="text-xl font-semibold mb-3">
//                     Confirm Email Validation
//                   </p>
//                   <p className="text-base mx-20 mb-5">
//                     A Verification link has been sent to your email account.
//                     Please check your email and click on the link to proceed!
//                   </p>
//                 </div>

//                 <Link to={"/"}>
//                   <p className="text-gray-400 text-base mt-3">
//                     Skip, I'll Confirm Later
//                   </p>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Signup;
import React, { useState, useEffect } from "react";
import {
  InputLabel,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import BaseURL from "../../api/baseURL";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { FaLock } from "react-icons/fa";

const Signup_URL = "/user/signup";

const Signup = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    type: 1,
    companyName: "",
  });

  const [isEmailSuccessfullySent, setIsEmailSuccessfullySent] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [formErrors, setFormErrors] = useState({
    fullNameError: false,
    companyNameError: false,
    emailError: false,
    passwordError: false,
    confirmPasswordError: false,
    typeError: false,
  });

  useEffect(() => {
    const isPasswordValid =
      values.password.length >= 8 &&
      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(values.password);
    setPasswordError(!isPasswordValid);
    setConfirmPasswordError(values.confirmPassword !== values.password);
  }, [values.password, values.confirmPassword]);

  const handleChange = (name) => (e) => {
    const value = e.target.value;
    setValues({ ...values, [name]: value });
  };

  const isFormValid = () => {
    return (
      values.fullName &&
      values.email &&
      values.companyName &&
      values.password &&
      values.confirmPassword &&
      !passwordError &&
      !confirmPasswordError
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (passwordError || confirmPasswordError) {
      toast.error("Please fix password errors before continuing.");
      return;
    }
    if (!isFormValid()) {
      toast.error("Please fill the form correctly before continuing.");
      return;
    }
  
    setIsLoading(true);
  
    try {
      const { data } = await BaseURL.post(Signup_URL, {
        ...values,
        type: parseInt(values.type),
      });
  
      if (data.statusCode === 200) {
        setValues({
          fullName: "",
          companyName: "",
          email: "",
          type: 1,
          password: "",
          confirmPassword: "",
        });
        toast.success("Sign up successful, please login!");
        setIsEmailSuccessfullySent(true);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        const errorMessage = err.response.data.message;
        switch (errorMessage) {
          case "Invalid e-mail address":
          case "E-mail address already exists":
            toast.error(errorMessage);
            break;
          default:
            toast.error(errorMessage);
            break;
        }
      } else {
        toast.error(err);
      }
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleOpenEmailApp = () => {
    window.open("https://mail.google.com", "_blank");
  };

  return (
    <div>
      {!isEmailSuccessfullySent ? (
        <div
          className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative"
          style={{
            background:
              "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
            backgroundColor: "rgb(23,39,92)",
          }}
        >
          <div className="sm:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2 "></div>
          <div
            className="sm:col-span-4 flex justify-center items-center text-3xl  p-2 border-l-2"
            style={{ borderColor: "#214471" }}
          >
            <div className="w-fit flex justify-center">
              <form
                className="flex flex-col w-full items-center"
                onSubmit={handleSubmit}
              >
                <h1 className="text-white font-semibold text-3xl mb-10 text-center">
                  Sign Up
                </h1>
                <div className="flex flex-col mb-4 w-96 text-white">
                  <InputLabel
                    className="text-white mb-1 text-base"
                    style={{ color: "white" }}
                  >
                    Full Name
                  </InputLabel>
                  <TextField
                    type="text"
                    variant="outlined"
                    size="small"
                    placeholder="Full Name"
                    name="fullName"
                    value={values.fullName}
                    onChange={handleChange("fullName")}
                    required
                    error={formErrors.fullNameError}
                    InputProps={{
                      style: {
                        background: "white",
                        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                        borderColor: formErrors.fullNameError
                          ? "red"
                          : "initial",
                      },
                    }}
                  />
                  {formErrors.fullNameError && (
                    <p className="text-red-500 text-sm">
                      Please enter your full name
                    </p>
                  )}
                </div>
                {values.type === 1 && (
                  <div className="flex flex-col mb-4 w-96 text-white">
                    <InputLabel
                      className="text-white mb-1 text-base"
                      style={{ color: "white" }}
                    >
                      Company Name
                    </InputLabel>
                    <TextField
                      type="text"
                      variant="outlined"
                      size="small"
                      placeholder="Company Name"
                      name="companyName"
                      value={values.companyName}
                      onChange={handleChange("companyName")}
                      required
                      error={formErrors.companyNameError}
                      InputProps={{
                        style: {
                          background: "white",
                          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                          borderColor: formErrors.companyNameError
                            ? "red"
                            : "initial",
                        },
                      }}
                    />
                    {formErrors.companyNameError && (
                      <p className="text-red-500 text-sm">
                        Please enter the company name
                      </p>
                    )}
                  </div>
                )}

                <div className="flex flex-col mb-4 w-96">
                  <InputLabel
                    className="text-white mb-1 text-base"
                    style={{ color: "white" }}
                  >
                    Email
                  </InputLabel>
                  <TextField
                    type="email"
                    variant="outlined"
                    size="small"
                    placeholder="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange("email")}
                    required
                    error={formErrors.emailError}
                    InputProps={{
                      style: {
                        background: "white",
                        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                        borderColor: formErrors.emailError ? "red" : "initial",
                      },
                    }}
                  />
                  {formErrors.emailError && (
                    <p className="text-red-500 text-sm">
                      Invalid e-mail address, please try again.
                    </p>
                  )}
                </div>
                <div className="flex flex-col mb-4 w-96">
                  <InputLabel
                    className="text-white mb-1 text-base"
                    style={{ color: "white" }}
                  >
                    User Role
                  </InputLabel>
                  <TextField
                    type="text"
                    variant="outlined"
                    size="small"
                    name="type"
                    value={values.type === 1 ? "Admin" : ""}
                    onChange={handleChange("type")}
                    required
                    disabled
                    error={formErrors.typeError}
                    InputProps={{
                      style: {
                        background: "white",
                        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                        borderColor: formErrors.typeError ? "red" : "initial",
                        color: "black",
                      },
                      endAdornment: (
                        <div style={{ position: "relative" }}>
                          <FaLock
                            style={{
                              position: "absolute",
                              right: "8px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#ccc",
                            }}
                          />
                        </div>
                      ),
                    }}
                  />
                </div>
                <div className="flex flex-col mb-4 w-96">
                <InputLabel
                    className="text-white mb-1 text-base"
                    style={{ color: "white" }}
                  >
                    Password
                  </InputLabel>
                  <TextField
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    placeholder="Password"
                    name="password"
                    value={values.password}
                    onChange={handleChange("password")}
                    required
                    error={passwordError}
                    InputProps={{
                      style: {
                        background: "white",
                        borderColor: formErrors.passwordError
                          ? "red"
                          : "initial",
                        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleTogglePasswordVisibility}>
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    // onCopy={(e) => e.preventDefault()}
                    // onCut={(e) => e.preventDefault()}
                    // onPaste={(e) => e.preventDefault()}
                  />
                  {passwordError && (
                    <p className="text-red-500 text-sm">Password must meet all validation criteria.</p>
                  )}
                </div>
                <div className="flex flex-col mb-4 w-96">
                <InputLabel
                    className="text-white mb-1 text-base"
                    style={{ color: "white" }}
                  >
                    Confirm Password
                  </InputLabel>
                  <TextField
                    type={showConfirmPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    placeholder="Confirm Password"
                    name="confirmPassword"
                    value={values.confirmPassword}
                    onChange={handleChange("confirmPassword")}
                    required
                    error={confirmPasswordError}
                    InputProps={{
                      style: {
                        background: "white",
                        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                        borderColor: formErrors.confirmPasswordError
                          ? "red"
                          : "initial",
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleToggleConfirmPasswordVisibility}
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    // onCopy={(e) => e.preventDefault()}
                    // onCut={(e) => e.preventDefault()}
                    // onPaste={(e) => e.preventDefault()}
                  />
                  {confirmPasswordError && (
                    <p className="text-red-500 text-sm">
                      Passwords do not match.
                    </p>
                  )}
                </div>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ textTransform: "none" }}
                  className="w-30 h-8 rounded-md mb-4 font-bold text-lg text-sm"
                  disabled={!isFormValid() || isLoading}
                  style={{
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
                    color: !isFormValid() ? "" : "#081A51",
                    backgroundColor: !isFormValid() ? "" : "white",
                    fontWeight: !isFormValid() ? "" : "bold",
                  }}
                >
                  {isLoading ? <CircularProgress size={24} /> : "Continue"}
                </Button>
                <p className="text-white text-base mt-5">
                  Have an account?{" "}
                  <Link to="/" className="text-white border-b-2 text-base ml-1">
                    Login
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative"
          style={{
            background:
              "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
            backgroundColor: "rgb(23,39,92)",
          }}
        >
          <div className="sm:col-span-12 md:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2"></div>

          <div
            className="sm:col-span-6 flex justify-center items-center text-3xl p-2 border-l-2 relative"
            style={{ borderColor: "#214471" }}
          >
            <div className="w-full flex justify-center items-center">
              <div className="absolute inset-y-1/2 transform -translate-y-1/2 right-15 sm:right-25 w-2/3 bg-white rounded-lg h-2/3 flex flex-col justify-center items-center">
                <div className="flex justify-center items-center w-1/3 h-1/3 bg-blue-950 rounded-full">
                  <MdEmail style={{ color: "white", fontSize: "4em" }} />
                </div>
                <div className="text-center mt-8">
                  <p className="text-xl font-semibold mb-3">
                    Confirm Email Validation
                  </p>
                  <p className="text-base mx-20 mb-5">
                    A Verification link has been sent to your email account.
                    Please check your email and click on the link to proceed!
                  </p>
                </div>

                <Link to={"/"}>
                  <p className="text-gray-400 text-base mt-3">
                    Skip, I'll Confirm Later
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Signup;
